import InteractiveAnnotation from "./interactiveAnnotation";
import { angleOffset } from "../geometry";
import Line from "./line";
import { drawBoxes, setLineStyle } from "../canvasUtils";
export default class Arrow extends InteractiveAnnotation {
  constructor(position, options) {
    super(position, options);

    this.line = new Line(position, options);
    this.line.headOffset = 3;

    this.arrowOuterLength = 25;
    this.arrowInnerLength = 12;
    this.arrowAngle = 3 * Math.PI / 16;
  }

  get corner1() {
    const offset = angleOffset(this.arrowOuterLength + (this.lineWidth * 1.5), this.line.angle - this.arrowAngle);
    return { x: this.line.headX + offset.x, y: this.line.headY + offset.y };
  }

  get inner() {
    const offset = angleOffset(this.arrowInnerLength + (this.lineWidth * 1.5), this.line.angle);
    return { x: this.line.headX + offset.x, y: this.line.headY + offset.y };
  }

  get corner2() {
    const offset = angleOffset(this.arrowOuterLength + (this.lineWidth * 1.5), this.line.angle + this.arrowAngle);
    return { x: this.line.headX + offset.x, y: this.line.headY + offset.y };
  }

  get outer() {
    const offset = {
      x: this.lineWidth * Math.cos(this.line.angle), 
      y: this.lineWidth * Math.sin(this.line.angle)
    };
    return { x: this.line.headX - offset.x, y: this.line.headY - offset.y };
  } 

  draw(ctx) {
    this.line.draw(ctx);
    this.drawArrow(ctx);

    if (this.line.isActive) drawBoxes(ctx, this.line.interactionPoints, this.line.transform.zoom);
  }

  drawArrow(ctx) {
    setLineStyle(ctx, this);
    ctx.beginPath();
    let outer = this.outer;
    let corner1 = this.corner1;
    let inner = this.inner;
    let corner2 = this.corner2;
    ctx.moveTo(outer.x, outer.y);
    ctx.lineTo(corner1.x, corner1.y);
    ctx.lineTo(inner.x, inner.y);
    ctx.lineTo(corner2.x, corner2.y);
    ctx.lineTo(outer.x, outer.y);
    ctx.closePath();
    ctx.fill();
  }

  isInBounds(x, y) {
    return this.line.isInBounds(x, y);
  }

  mousedown(x, y) {
    this.line.mousedown(x, y);
    this.signalReady();
  }

  mousemove(x, y) {
    this.line.mousemove(x, y);
    this.signalReady();
  }

  deactivate() {
    this.line.clearActiveState();
    this.signalReady();
  }

  setParentTransform(obj) {
    this.line.setParentTransform(obj);
    this.signalReady();
  }

  setLineWidth(width) {
    super.setLineWidth(width);
    this.line.setLineWidth(width);
    this.signalReady();
  }
  
  updateColor(color) 
  {
    this.line.color = color;
    this.color = color;
  }
}